/* IMPORT */
import { BATCH } from '../context.js';
import SchedulerAsync from '../objects/scheduler.async.js';
import SchedulerSync from '../objects/scheduler.sync.js';
/* MAIN */
const isBatching = () => {
    return !!BATCH || SchedulerAsync.queued || SchedulerAsync.locked || SchedulerSync.locked;
};
/* EXPORT */
export default isBatching;
